var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResetFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2506 4.18011C12.9994 4.50947 13.0627 4.9801 13.3921 5.23128C15.1804 6.59515 16.25 8.70821 16.25 11C16.25 14.736 13.4242 17.812 9.7933 18.2071L10.4697 17.5303C10.7626 17.2374 10.7626 16.7626 10.4697 16.4697C10.2034 16.2034 9.7867 16.1792 9.4931 16.3971L9.409 16.4697L7.409 18.4697C7.1427 18.7359 7.1185 19.1526 7.3364 19.4462L7.409 19.5303L9.409 21.5303C9.7019 21.8232 10.1768 21.8232 10.4697 21.5303C10.7359 21.2641 10.7601 20.8474 10.5423 20.5538L10.4697 20.4697L9.7194 19.7208C14.2154 19.355 17.75 15.5903 17.75 11C17.75 8.23526 16.4582 5.68321 14.3017 4.03856C13.9724 3.78738 13.5017 3.85075 13.2506 4.18011ZM7.5303 0.469668C7.2374 0.762558 7.2374 1.23744 7.5303 1.53033L8.2796 2.27923C3.78409 2.6456 0.25 6.41008 0.25 11C0.25 13.6445 1.43126 16.0974 3.43081 17.7491C3.75016 18.0129 4.22289 17.9679 4.48669 17.6485C4.75048 17.3292 4.70545 16.8564 4.3861 16.5926C2.72793 15.2229 1.75 13.1922 1.75 11C1.75 7.26436 4.57532 4.18861 8.2057 3.79301L7.5303 4.46967C7.2374 4.76256 7.2374 5.23744 7.5303 5.53033C7.8232 5.82322 8.2981 5.82322 8.591 5.53033L10.591 3.53033C10.8839 3.23744 10.8839 2.76256 10.591 2.46967L8.591 0.469668C8.2981 0.176777 7.8232 0.176777 7.5303 0.469668Z",
    fill: "url(#paint0_linear_390_3357)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_390_3357",
    x1: 0.25,
    y1: 12.3437,
    x2: 17.75,
    y2: 12.3437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBF2E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetFilter);
export default __webpack_public_path__ + "static/media/reset_filter.d5f0defbeb0f417be04dac6928892e2d.svg";
export { ForwardRef as ReactComponent };